import { render, staticRenderFns } from "./calc_susong.vue?vue&type=template&id=892ab86a&scoped=true&"
import script from "./calc_susong.vue?vue&type=script&lang=js&"
export * from "./calc_susong.vue?vue&type=script&lang=js&"
import style0 from "./calc_susong.vue?vue&type=style&index=0&id=892ab86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892ab86a",
  null
  
)

export default component.exports